
// Interface for the project data structure
export interface Project {
    id: number;
    name: string;
    metaDescription?: string | null;
    metaKeywords?: string | null;
    metaImg?: string | null,
    urlSlug?: string | null;
    company?: string | null;
    position?: string | null;
    companyLink?: string | null;
    thumbnailUrl?: string | null;
    featured: boolean;
    responsibilities?: string | null;
    about?: string | null;
    projectLink?: string | null;
    flags: string[];
    techStacks: string[];
    media: {
        filename: string | null;
        youtubeId: string | null | undefined;
        type: 'image' | 'video';
        caption?: string | null | undefined;
    }[];
    links: {
        title: string;
        url: string;
        type: string | null;
    }[];
}

// Interface for our "Rows"
// We group projects into rows, each with a specific layout type.
export interface ProjectRow {
    id: string; // A unique ID for the React key
    type: 'FNN' | 'NNF' | 'NNN' | 'FALLBACK'; // The layout pattern
    items: Project[]; // The projects in this row
}

// Gets the correct image path (with a default fallback)
export const getProjectImagePath = (img: string | null) => {
    if (!img) return '/assets/imgs/data/projects/default-project.jpg';
    return `/assets/imgs/data/${img}`;
};
export const getLinkImagePath = (type: string | null) => {
    if (!type) return '/assets/imgs/links/default_link.png';
    return `/assets/imgs/links/${type}_link.png`;
};
export const getProjectMediaPath = (item: Project['media'][0])=> {
    if (item.type === 'image' && item.filename) {
        return `/assets/imgs/data/${item.filename}`; // Adjust this path if needed
    }
    if (item.type === 'video' && item.filename) {
        return `/assets/videos/data/${item.filename}`; // Adjust this path if needed
    }
    return '';
};

export interface ProjectModalProps {
    project: Project | null;
    onClose?: () => void;
    onCloseAction?: string;
}